import {
  FlexBox,
  FlexBoxProps,
  PageWithActions,
} from '@airship-platform/jam-web/components';
import Button, { ButtonProps } from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

type ActionButton = ButtonProps<'button', { to?: string; label: string }>;

type SectionWrapperProps = {
  header?: string;
  subheader?: string;
  actionsButtons?: {
    left?: ActionButton;
    right?: ActionButton;
  };
} & FlexBoxProps;

const SectionWrapper: React.FC<PropsWithChildren<SectionWrapperProps>> = ({
  header,
  subheader,
  actionsButtons,
  children,
  ...props
}) => (
  <PageWithActions
    actionsComponent={
      <FlexBox justifyContent={'space-between'} width={'100%'}>
        {actionsButtons?.left && (
          <Button
            type="button"
            color="softGold"
            size="large"
            {...actionsButtons.left}
          >
            {actionsButtons.left.label}
          </Button>
        )}
        {actionsButtons?.right && (
          <Button size="large" color="primary" {...actionsButtons.right}>
            {actionsButtons.right.label}
          </Button>
        )}
      </FlexBox>
    }
  >
    <FlexBox flexDirection={'column'} alignItems={'center'}>
      <FlexBox
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
        {...props}
      >
        <FlexBox
          gap={1}
          width={'100%'}
          alignSelf={'flex-start'}
          flexDirection={'column'}
          mb={3}
        >
          {header && <Typography variant={'h3'}>{header}</Typography>}
          {subheader && <Typography variant={'body2'}>{subheader}</Typography>}
        </FlexBox>
        {children}
      </FlexBox>
    </FlexBox>
  </PageWithActions>
);

export default SectionWrapper;
